import indexEn from './en/en.json'
import indexAr from './ar/ar.json'
import indexEs from './es/es.json'
import indexDe from './de/de.json'
import indexIt from './it/it.json'
import indexFr from './fr/fr.json'
import indexPt from './pt/pt.json'
import indexEl from './el/el.json'
import indexBn from './bn/bn.json'
import indexSr from './sr/sr.json'
import indexCs from './cs/cs.json'
import indexPl from './pl/pl.json'
import indexHu from './hu/hu.json'
import indexSk from './sk/sk.json'
import indexRo from './ro/ro.json'
import indexBg from './bg/bg.json'
import indexMk from './mk/mk.json'
import indexSq from './sq/sq.json'

const IndexMessages = {
  en: { index: { ...indexEn } },
  ar: { index: { ...indexAr } },
  es: { index: { ...indexEs } },
  de: { index: { ...indexDe } },
  it: { index: { ...indexIt } },
  fr: { index: { ...indexFr } },
  pt: { index: { ...indexPt } },
  el: { index: { ...indexEl } },
  bn: { index: { ...indexBn } },
  sr: { index: { ...indexSr } },
  cs: { index: { ...indexCs } },
  pl: { index: { ...indexPl } },
  hu: { index: { ...indexHu } },
  sk: { index: { ...indexSk } },
  ro: { index: { ...indexRo } },
  bg: { index: { ...indexBg } },
  mk: { index: { ...indexMk } },
  sq: { index: { ...indexSq } },
}

export default IndexMessages
